var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.461,
    height: 43.461,
    viewBox: "0 0 43.461 43.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0.715 0.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M162.916,326.227A21.643,21.643,0,0,0,159.8,333h9.885Z",
    transform: "translate(-159.804 -317.679)",
    fill: "#0c2865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M182.805,309.124a21.66,21.66,0,0,0-6.864,3.41l6.864,6.865Z",
    transform: "translate(-167.876 -309.124)",
    fill: "#0c2865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M176.962,380.145a21.63,21.63,0,0,0,6.354,3.047v-9.4Z",
    transform: "translate(-168.386 -341.471)",
    fill: "#0c2865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M160.3,363.7a21.631,21.631,0,0,0,3.227,6.407l6.407-6.407Z",
    transform: "translate(-160.054 -336.423)",
    fill: "#0c2865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0.316 0.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M162.875,325.217q-.182.25-.359.5l6.773,6.773H159.4c-.16.609-.291,1.231-.4,1.861h13.008Z",
    transform: "translate(-159.006 -316.718)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M175.954,377.06c.165.123.335.24.5.359l6.354-6.353v9.4c.61.179,1.231.332,1.861.456v-12.58Z",
    transform: "translate(-167.483 -338.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M159.337,359.977c.135.63.294,1.252.482,1.861h9.634l-6.407,6.407a21.848,21.848,0,0,0,2.309,2.672l10.94-10.94Z",
    transform: "translate(-159.172 -334.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M180.152,308.667v10.275l-6.864-6.864a21.8,21.8,0,0,0-2.651,2.331l11.376,11.375V308.211C181.383,308.335,180.762,308.49,180.152,308.667Z",
    transform: "translate(-164.824 -308.211)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(15.579 16.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M189.61,363.569l-.065.066h.065Z",
    transform: "translate(-189.544 -351.614)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M193.268,359.911h.065v-.066Z",
    transform: "translate(-191.407 -349.751)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M209.938,343.5h-.063v.063Z",
    transform: "translate(-199.714 -341.575)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M189.739,339.713l-.064-.065v.065Z",
    transform: "translate(-189.61 -339.648)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M193.4,343.372v.064h.064Z",
    transform: "translate(-191.472 -341.511)",
    fill: "#c60624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(27.601 0.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M213.6,379.547v4.871a21.6,21.6,0,0,0,6.442-3.018l-5.278-5.278A17.113,17.113,0,0,1,213.6,379.547Z",
    transform: "translate(-213.598 -342.576)",
    fill: "#112657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M214.789,318.146l5.762-5.762A21.644,21.644,0,0,0,213.6,309v5A19.241,19.241,0,0,1,214.789,318.146Z",
    transform: "translate(-213.598 -309.003)",
    fill: "#112657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M230.227,370.234a21.669,21.669,0,0,0,3.317-6.534h-9.85Z",
    transform: "translate(-218.648 -336.362)",
    fill: "#112657"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M233.79,332.873a21.636,21.636,0,0,0-3.2-6.9l-6.9,6.9Z",
    transform: "translate(-218.645 -317.492)",
    fill: "#112657"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(25.74 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M218.52,360.345l1.493,1.493,7.148,7.148c.162-.2.323-.405.479-.614l-6.534-6.534h9.85q.281-.914.481-1.861H218.659C218.639,360.241,218.545,360.083,218.52,360.345Z",
    transform: "translate(-214.199 -334.066)",
    fill: "#e2e2e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M215.524,322.62,222,316.141c-.162-.126-.325-.251-.491-.373l-5.762,5.762C215.809,321.758,215.468,322.386,215.524,322.62Z",
    transform: "translate(-212.697 -311.953)",
    fill: "#e2e2e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M211.735,313.172v-4.6q-.915-.257-1.861-.434v2.246A12.017,12.017,0,0,1,211.735,313.172Z",
    transform: "translate(-209.874 -308.134)",
    fill: "#e2e2e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M217.829,332.006h13.23c-.107-.63-.238-1.251-.4-1.861h-10.1l6.9-6.9a21.83,21.83,0,0,0-2.256-2.724l-7.772,7.771C217.64,329.7,217.734,330.521,217.829,332.006Z",
    transform: "translate(-213.654 -314.33)",
    fill: "#e2e2e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M215.3,371.6l5.593,5.593a21.787,21.787,0,0,0,2.623-2.128l-7.356-7.356A37.719,37.719,0,0,1,215.3,371.6Z",
    transform: "translate(-212.587 -337.933)",
    fill: "#e2e2e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M209.875,385.777v2.5q.946-.176,1.861-.434v-4.871A12.1,12.1,0,0,1,209.875,385.777Z",
    transform: "translate(-209.875 -345.57)",
    fill: "#e2e2e1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M216.852,326.288l7.771-7.771a21.7,21.7,0,0,0-2.243-2l-6.107,6.107C216.545,323.755,216.669,325.054,216.852,326.288Z",
    transform: "translate(-187.335 -311.951)",
    fill: "#cb061d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(20.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M199.681,307.41c.362-.017.723-.026,1.085-.026Q200.221,307.384,199.681,307.41Z",
    transform: "translate(-199.681 -307.384)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M200.767,394.314c-.361,0-.722-.01-1.084-.028Q200.222,394.314,200.767,394.314Z",
    transform: "translate(-199.682 -350.853)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M201.851,391.46a21.771,21.771,0,0,0,4.01-.376v-2.5C204.72,389.818,203.384,391.46,201.851,391.46Z",
    transform: "translate(-200.766 -347.999)",
    fill: "#c60624"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(29.311 18.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M231.566,343.5H218.508a58.415,58.415,0,0,1-.062,8.235H231.4a21.677,21.677,0,0,0,.165-8.235Z",
    transform: "translate(-217.732 -343.5)",
    fill: "#cb061d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M217.769,360.713c-.12,1.284-.541,2.285-.751,3.5l7.356,7.356a21.836,21.836,0,0,0,2.035-2.211l-7.147-7.148Z",
    transform: "translate(-217.018 -352.11)",
    fill: "#cb061d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M205.861,310.166v-2.407a21.848,21.848,0,0,0-4.01-.375C203.384,307.384,204.72,308.929,205.861,310.166Z",
    transform: "translate(-180.121 -307.384)",
    fill: "#c60624"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(27.601 4.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M213.6,379.322a23.417,23.417,0,0,0,1.514-4.015l-1.514-1.514Z",
    transform: "translate(-213.598 -345.344)",
    fill: "#0c2865"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M215.3,321.571a24.436,24.436,0,0,0-1.7-4.7v6.4Z",
    transform: "translate(-213.598 -316.871)",
    fill: "#0c2865"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(25.74 1.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M218.574,360.766q.037-.393.068-.789h-.858Z",
    transform: "translate(-213.831 -335.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M211.735,320.478v-6.4a12.015,12.015,0,0,0-1.861-2.792V323.2l3.738-3.738c-.056-.233-.115-.462-.174-.69Z",
    transform: "translate(-209.874 -311.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M210,339.14h4.811c-.094-1.485-.244-2.947-.453-4.356Z",
    transform: "translate(-209.937 -323.039)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M209.875,375.5a12.048,12.048,0,0,0,1.861-2.792v-5.528l1.513,1.514a37.435,37.435,0,0,0,.874-3.878l-4.249-4.248V375.5Z",
    transform: "translate(-209.875 -335.933)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M184.114,348.9V333.963l4.248,4.249c.209-1.212.373-2.468.494-3.753l-.79-.789h.858a58.416,58.416,0,0,0,.062-8.235h-4.81l4.357-4.356c-.184-1.234-.411-2.429-.682-3.564l-3.737,3.737V309.334a5.4,5.4,0,0,0-4.01-1.95c-.361,0-.722.009-1.084.026a22,22,0,0,0-3.14.387v17.573L164.5,314a21.95,21.95,0,0,0-1.944,2.3l7.277,7.278,1.862,1.861H158.689a21.674,21.674,0,0,0,.165,8.235h16.959l-10.94,10.94a21.861,21.861,0,0,0,2.287,1.959l8.718-8.719v12.58a21.867,21.867,0,0,0,3.141.387c.361.018.722.028,1.084.028A5.4,5.4,0,0,0,184.114,348.9Z",
    transform: "translate(-158.373 -307.384)",
    fill: "#dc0028"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.ee348cc335862eddf12d14902e255ff9.svg";
export { ForwardRef as ReactComponent };